export default __webpack_public_path__ + "static/Partnership-2054520b31b07d767ced8fc2ee086017.svg";